(function () {
  'use strict';

  var CONSENT_KEY = 'e3_cookie_consent';
  var CONSENT_VERSION = 1;

  var banner = document.getElementById('cookie-banner');
  var modal = document.getElementById('cookie-modal');
  var settingsBtn = document.getElementById('cookie-settings-btn');

  function getConsent() {
    try {
      var raw = localStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data.version !== CONSENT_VERSION) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function setConsent(prefs) {
    var data = {
      version: CONSENT_VERSION,
      timestamp: new Date().toISOString(),
      essential: true,
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(data));
    applyConsent(data);
  }

  function applyConsent(data) {
    if (data.analytics) {
      document.documentElement.setAttribute('data-cookie-analytics', 'granted');
    } else {
      document.documentElement.removeAttribute('data-cookie-analytics');
    }
    if (data.marketing) {
      document.documentElement.setAttribute('data-cookie-marketing', 'granted');
    } else {
      document.documentElement.removeAttribute('data-cookie-marketing');
    }
  }

  function showBanner() {
    banner.removeAttribute('hidden');
    settingsBtn.hidden = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('cookie-banner--visible');
      });
    });
  }

  function hideBanner() {
    banner.classList.remove('cookie-banner--visible');
    banner.setAttribute('hidden', '');
  }

  function showModal() {
    var consent = getConsent();
    document.getElementById('cookie-analytics').checked = consent ? consent.analytics : false;
    document.getElementById('cookie-marketing').checked = consent ? consent.marketing : false;
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('cookie-modal--visible');
      });
    });
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    modal.classList.remove('cookie-modal--visible');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function acceptAll() {
    setConsent({ analytics: true, marketing: true });
    hideBanner();
    settingsBtn.hidden = false;
  }

  function rejectAll() {
    setConsent({ analytics: false, marketing: false });
    hideBanner();
    settingsBtn.hidden = false;
  }

  function savePreferences() {
    setConsent({
      analytics: document.getElementById('cookie-analytics').checked,
      marketing: document.getElementById('cookie-marketing').checked
    });
    hideModal();
    hideBanner();
    settingsBtn.hidden = false;
  }

  function init() {
    var consent = getConsent();

    if (consent) {
      applyConsent(consent);
      settingsBtn.hidden = false;
      return;
    }

    showBanner();
  }

  document.getElementById('cookie-accept').addEventListener('click', acceptAll);
  document.getElementById('cookie-reject').addEventListener('click', rejectAll);
  document.getElementById('cookie-manage').addEventListener('click', function () {
    showModal();
  });

  document.getElementById('cookie-modal-close').addEventListener('click', hideModal);
  document.getElementById('cookie-modal-reject').addEventListener('click', function () {
    document.getElementById('cookie-analytics').checked = false;
    document.getElementById('cookie-marketing').checked = false;
    savePreferences();
  });
  document.getElementById('cookie-modal-save').addEventListener('click', savePreferences);
  document.getElementById('cookie-modal-accept').addEventListener('click', function () {
    document.getElementById('cookie-analytics').checked = true;
    document.getElementById('cookie-marketing').checked = true;
    savePreferences();
  });

  modal.querySelector('.cookie-modal__overlay').addEventListener('click', hideModal);

  settingsBtn.addEventListener('click', showModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) {
      hideModal();
    }
  });

  init();
})();
